//
//
//
//
//
//
//
//
//

export default {
  name: 'maskings',
  data() {
    return {}
  },
  props: {
    bgcolor: {
      type: String | Number,
      default: 'rgba(0, 0, 0, .4)'
    },
    zindex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    emitClick() {
      this.$emit('click')
    },
    onTouchMove(e) {
      e.preventDefault()
    }
  },
  mounted() {
    // console.log('mask mounted')
    this.$store.dispatch('setOverlayed', true)
  },
  destroyed() {
    // console.log('mask destroyed')
    this.$store.dispatch('setOverlayed', false)
  }
}



// WEBPACK FOOTER //
// ./src/components/el-masking.vue